import { FC } from 'react'
import { Stack, Tooltip, Typography } from '@mui/material'
import LocationWarningIcon from '../../../../assets/images/location-warning.svg?react'

interface ContactCardProps {
  label: string
  contactName: string
  contactPhoneNumber?: string
  isProfessionallyMonitored?: boolean
  additionalContactTooltip?: string
  ['data-testid']?: string
  shouldReserveEmptyPrimaryNameLine?: boolean
}

export const ContactCard: FC<ContactCardProps> = ({
  label,
  contactName,
  contactPhoneNumber,
  isProfessionallyMonitored,
  additionalContactTooltip,
  ['data-testid']: dataTestId,
  shouldReserveEmptyPrimaryNameLine = false
}) => {
  const disabledFieldStyle = !isProfessionallyMonitored ? { color: 'var(--text-disabled)' } : {}

  return (
    <Stack
      direction="column"
      spacing="var(--spacing-2xs)"
      useFlexGap
      sx={{
        border: '1px solid var(--border-neutral)',
        borderRadius: 'var(--border-radius-l)',
        padding: 'var(--spacing-s)'
      }}
      data-testid={dataTestId}
    >
      <Typography sx={{ fontWeight: '700', ...disabledFieldStyle }}>{label}</Typography>
      <Stack direction="row" useFlexGap spacing="var(--spacing-2xs)" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography
          sx={{
            wordBreak: 'break-word',
            minHeight: shouldReserveEmptyPrimaryNameLine ? '1.5em' : undefined,
            ...disabledFieldStyle
          }}
        >
          {contactName}
        </Typography>
        {additionalContactTooltip && (
          <Tooltip title={additionalContactTooltip} arrow>
            <LocationWarningIcon />
          </Tooltip>
        )}
      </Stack>
      <Typography sx={{ ...disabledFieldStyle }}>{contactPhoneNumber}</Typography>
    </Stack>
  )
}
